export default "__VITE_ASSET__BziIke48__"